import { useContext } from "react";
import AuthContext from "../context/AuthProvidor";

const useAuth = () => {
    return useContext(AuthContext);
}

export default useAuth;